module.exports = __webpack_public_path__ + "media/both.d6b9e8a5.mp3";